<template>
	<div class="study">
		<publicHeader></publicHeader>
		<div class="help_header bg_gray">
			<div class="w1200 flex">
				<div class="flex">
					<img :src="public.top_logo" class="study_header_logo" />
					<div class="f20px study_header_name">·&nbsp;&nbsp;&nbsp;&nbsp;帮助中心</div>
				</div>
			</div>
		</div>
		<div class="help_details_cont bg_gray">
			<div class="w1200 bg_white radius8">
				<div class="help_item_cont" v-html="details.content"></div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'help_details',
		components: {
			publicHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				public: {},
				id: "",
				details: {},
			}
		},
		mounted() {
			this.getDetails();
		},
		created() {
			this.id = this.$route.query.id;
		},
		watch: {
			$route: {
				handler () {
					this.id = this.$route.query.id;
					this.getDetails();
				}
			}
		},
		methods: {
			publicEvent (data) {
				this.public = data;
			},
			getDetails () {
				this.$get("/api/article/get_article_sel",{
					id: this.id,
				})
				.then(res => {
					this.details = res.data;
				});
			},
			searchBtn () {
				
			},
		},
	}
</script>

<style>
</style>
